import { Stack } from "@mui/material";
import FieldLabel from "components/FieldLabel";
import DateRangePickerControl from "components/form/DateRangePickerControl";

interface AvailableRangeControlProps {
  disabled?: boolean;
}

const AvailableRangeControl = ({ disabled }: AvailableRangeControlProps) => {
  return (
    <Stack
      spacing={0.5}
      useFlexGap>
      <FieldLabel
        label='Срок проведения тестирования'
        tooltipProps={{
          title:
            // eslint-disable-next-line max-len
            "После указанной даты доступ к тестированию для кандидатов будет заблокирован. Срок можно продлить, изменив дату окончания.",
        }}
      />
      <DateRangePickerControl
        name='availableRange'
        disabled={disabled}
      />
    </Stack>
  );
};

export default AvailableRangeControl;
